import { render, staticRenderFns } from "./RedPackageSettlement.vue?vue&type=template&id=64d26946&scoped=true&"
import script from "./RedPackageSettlement.vue?vue&type=script&lang=js&"
export * from "./RedPackageSettlement.vue?vue&type=script&lang=js&"
import style0 from "./RedPackageSettlement.vue?vue&type=style&index=0&id=64d26946&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d26946",
  null
  
)

component.options.__file = "RedPackageSettlement.vue"
export default component.exports